import { $t } from '@/i18n';
import qs from 'query-string';
import wujiFetch from '@/utils/wujiFetch';
import getXyManagePathPrefix from '@utils/getXyManagePathPrefix';
import reporter from '@/reporter/instance/designerReport';
import { getPageConfigExtension } from '@utils/offline';

const fetchPage = async ({ projectId, pageId }, query = {}) => {
  const queryString = qs.stringify(query);
  const page = await wujiFetch(`${getXyManagePathPrefix()}/page/${pageId}${getPageConfigExtension()}?projectid=${projectId}${queryString ? `&${queryString}` : ''}`);
  return page;
};

const fetchLatestModifiedPage = async ({ projectId }) => await wujiFetch(`${getXyManagePathPrefix()}/page/latest-modified?projectid=${encodeURIComponent(projectId)}`);

const updatePage = async ({ data, pageId, projectId }, headers = {}) => {
  try {
    // 页面编辑行为的统一上报
    reporter.report('click', {
      mod: $t('k_2caf5ae8'),
      eid: $t('k_81cb80fb'),
      d1: pageId,
      d2: data?.type ?? undefined,
    });
  } catch (e) {}

  return await wujiFetch(`${getXyManagePathPrefix()}/page/${pageId}?projectid=${projectId}`, {
    method: 'PATCH',
    headers,
    body: JSON.stringify(data),
  });
};

const createPage = async ({ data, projectId }, headers = {}) => await wujiFetch(`${getXyManagePathPrefix()}/page?projectid=${projectId}`, {
  method: 'POST',
  headers,
  body: JSON.stringify(data),
});

const deletePage = async ({ projectId, pageId }, headers = {}) => await wujiFetch(`${getXyManagePathPrefix()}/page/${pageId}?projectid=${projectId}`, {
  method: 'DELETE',
  headers,
});

export default {
  fetchPage,
  fetchLatestModifiedPage,
  updatePage,
  createPage,
  deletePage,
};
